import type { Notices } from "@/lib/notices"

export const processNoticesRouteChange = ({
  notices,
}: {
  notices: Notices.Item[]
}): Notices.Collection => {
  return notices.reduce<Notices.Collection>((result, notice) => {
    if (!notice.persistence) {
      return result
    }

    const persistence = {
      ...notice.persistence,
      accruedRouteChanges: (notice.persistence.accruedRouteChanges || 0) + 1,
    }

    if (persistence.untilDismissed) {
      return { ...result, [notice.id]: { ...notice, persistence } }
    }

    if (persistence.accruedRouteChanges === persistence.maxRouteChanges) {
      return result
    }

    return { ...result, [notice.id]: { ...notice, persistence } }
  }, {})
}
